import {
  type NodeRenderer,
  type Options,
} from '@contentful/rich-text-react-renderer'
import { type BLOCKS, type INLINES } from '@contentful/rich-text-types'
import { type EntryMapper } from '@render-node/types'

export enum CUSTOMS {
  INLINE_IMAGE = 'image',
  HTML = 'html',
  CODE = 'code',
  BREAK = 'break',
  LINK_REFERENCE = 'linkReference',
  TABLE_CELL = 'tableCell', // deprecated
}

export type RichTextType = {
  rich?: string
  text?: string
  references?: readonly any[]
}

type BlocksWithoutContentTypeMapping = Omit<
  Record<BLOCKS, NodeRenderer>,
  BLOCKS.EMBEDDED_ENTRY | BLOCKS.EMBEDDED_ASSET
>

type InlinesWithoutContentTypeMapping = Omit<
  Record<INLINES, NodeRenderer>,
  INLINES.ENTRY_HYPERLINK | INLINES.EMBEDDED_ENTRY | INLINES.ASSET_HYPERLINK
>

export type RichTextOptions = Partial<Omit<Options, 'renderNode'>> & {
  renderNode: Partial<BlocksWithoutContentTypeMapping> &
    Partial<InlinesWithoutContentTypeMapping> &
    Partial<Record<CUSTOMS, NodeRenderer>> &
    Partial<{
      [INLINES.ENTRY_HYPERLINK]: EntryMapper
      [INLINES.ASSET_HYPERLINK]: EntryMapper
      [BLOCKS.EMBEDDED_ASSET]: EntryMapper
      [INLINES.EMBEDDED_ENTRY]: EntryMapper
      [BLOCKS.EMBEDDED_ENTRY]: EntryMapper
    }>
}
